import API from '@/services/API/paymentSummaries/PaymentSummariesService'

const getPaymentSummaries = async function({}, payload) {
    console.log('payload')
    console.log(payload)
    let response = await API.getPaymentSummaries(
        payload.cashDesk,
        payload.authCode
    )
    return response
}
const fetchInitialResume = async function({}, idCashdesk) {
    let response = await API.fetchInitialResume(idCashdesk)
    return response
}

const setInfoPaymentSummaries = function({ commit }, payloadInfo) {
    commit('SET_INFO_PAYMENT_SUMMARIES', payloadInfo)
}

const setDetailCustomerSummaries = function({ commit }, payload) {
    commit('SET_DETAIL_CUSTOMER_SUMMARIES', payload)
}

const setDetailEmployeeSummaries = function({ commit }, payload) {
    commit('SET_DETAIL_EMPLOYEE_SUMMARIES', payload)
}

const setDetailEgressSummaries = function({ commit }, payload) {
    commit('SET_DETAIL_EGRESS_SUMMARIES', payload)
}

const setTotalIncome = ({ commit }, income) => {
    commit('SET_TOTAL_INCOME', income)
}

const setTotalCustomerSummaries = function({ commit }, total) {
    commit('SET_TOTAL_CUSTOMER_SUMMARIES', total)
}

const setTotalEmployeeSummaries = function({ commit }, total) {
    commit('SET_TOTAL_EMPLOYEE_SUMMARIES', total)
}

const setInitialAmountCash = ({ commit }, amount) => {
    commit('SET_INITIAL_AMOUNT_CASH', amount)
}

const printArqueo = function({ state, getters, rootState }) {
    // después cambiar nombre a inglés
    let win = window.open('arqueo.html')

    //namespacing voucher data
    win.window.voucherData = {}

    //PREGUNTAR QUÉ OTROS DATOS FALTAN EN EL ARQUEO
    win.window.voucherData.title = 'ARQUEO DE CAJA'
    //win.window.voucherData.subtitle = `DOCN°${DOCNum(idMovCaja)}`
    //FIXME: Folio de arqueo
    win.window.voucherData.subtitle = '' //`DOCN°${DOCNum(999)}` // después poner id de verdad
    // win.window.voucherData.openingUser = state.openingUser
    const fullName = ({ names, last_name1 }) => `${names} ${last_name1}`
    win.window.voucherData.openingUser =
        rootState.AuthModule.user.name_case ||
        fullName(rootState.AuthModule.user.hr_employee)
    win.window.voucherData.openingTimeStamp = state.openingTimeStamp
    win.window.voucherData.initialAmountCash = state.initialAmountCash
    win.window.voucherData.totalCustomerSummaries = state.totalCustomerSummaries
    win.window.voucherData.detailCustomerSummaries =
        state.setDetailCustomerSummaries
    win.window.voucherData.totalEmployeeSummaries = state.totalEmployeeSummaries
    win.window.voucherData.detailEmployeeSummaries =
        state.setDetailEmployeeSummaries
    win.window.voucherData.detailEgressSummaries =
        state.setDetailEgressSummaries
    win.window.voucherData.totalIncome = state.totalIncome
    // n° folio
    win.window.preventPrint = rootState.SessionModule.preventPrint
    win.window.closeTimeout = process.env.VUE_APP_PRINTER_TIMEOUT

    // Después los items debo cargarlos de state.saleDetail
    //win.window.items = [{"id":1,"wh_item_id":1,"wh_pack_id":null,"wh_packing_id":null,"wh_promo_id":null,"wh_subfamily_id":71,"upc_code":"1405037584100","internal_code":"53677204","name":"Bebida Coca Cola Retornable 2 LT","alias_name":"Consequatur nemo accusantium animi.","description":"Sapiente ex quod aliquid iusto deleniti sed sunt vel quo quis.","warranty_days":730,"is_repackaged":true,"is_tax_free":false,"is_salable":true,"is_consumable":true,"is_seasonal":false,"flag_delete":false,"created_at":"2019-01-31 10:07:08","updated_at":"2019-01-31 10:07:08","sale_prices":[{"sale_price":100,"branch_office_id":1,"branch_office_address":"La Serena, Cienfuegos #301"}],"stocks":[{"g_branch_office_id":1,"g_branch_office_address":"La Serena, Cienfuegos #301","wh_warehouses":[{"wh_warehouse_id":1,"wh_warehouse_name":"BOD-001","wh_items":[{"wh_item_id":1,"wh_item_name":"Bebida Coca Cola Retornable 2 LT","wh_item_stock":995}],"logical_stock":995}]},{"g_branch_office_id":2,"g_branch_office_address":"Ovalle, Antofagasta #331","wh_warehouses":[{"wh_warehouse_id":2,"wh_warehouse_name":"BOD-002","wh_items":[{"wh_item_id":1,"wh_item_name":"Bebida Coca Cola Retornable 2 LT","wh_item_stock":1000}],"logical_stock":1000}]}],"sale_price":100,"default_warehouse":1,"stock":995,"active_warehouse":1,"quantity":7,"wholesaleDiscounts":[],"lineDiscount":{"percentage_discount":null,"unit_price_discount":null},"availableWholesaleDiscounts":[],"subtotal":700},{"id":2,"wh_item_id":2,"wh_pack_id":null,"wh_packing_id":null,"wh_promo_id":null,"wh_subfamily_id":30,"upc_code":"8853825278381","internal_code":"73568926","name":"Some Product","alias_name":"Dignissimos ut dolore odit.","description":"Quia fugit natus excepturi amet perspiciatis dignissimos et quas.","warranty_days":365,"is_repackaged":false,"is_tax_free":false,"is_salable":true,"is_consumable":true,"is_seasonal":false,"flag_delete":false,"created_at":"2019-01-31 10:07:08","updated_at":"2019-01-31 10:07:08","sale_prices":[{"sale_price":200,"branch_office_id":1,"branch_office_address":"La Serena, Cienfuegos #301"}],"stocks":[{"g_branch_office_id":1,"g_branch_office_address":"La Serena, Cienfuegos #301","wh_warehouses":[{"wh_warehouse_id":1,"wh_warehouse_name":"BOD-001","wh_items":[{"wh_item_id":2,"wh_item_name":"Some Product","wh_item_stock":995}],"logical_stock":995}]},{"g_branch_office_id":2,"g_branch_office_address":"Ovalle, Antofagasta #331","wh_warehouses":[{"wh_warehouse_id":2,"wh_warehouse_name":"BOD-002","wh_items":[{"wh_item_id":2,"wh_item_name":"Some Product","wh_item_stock":1000}],"logical_stock":1000}]}],"sale_price":200,"default_warehouse":1,"stock":995,"active_warehouse":1,"quantity":4,"wholesaleDiscounts":[{"id":9,"wh_product_id":2,"g_branch_office_id":2,"quantity_discount":40,"unit_price_discount":0,"percentage_discount":47,"flag_delete":false,"created_at":"2019-01-31 10:07:07","updated_at":"2019-01-31 10:07:07"}],"lineDiscount":{"percentage_discount":null,"unit_price_discount":null},"availableWholesaleDiscounts":[],"subtotal":800}]
    win.window.items = state.saleDetail
}

const DOCNum = function(idMovCaja) {
    // DESPUÉS MOVER A UN UTIL
    idMovCaja = idMovCaja.toString()
    // console.log('largo: ', idMovCaja.length)
    let zerosString = ''
    for (let i = 0; i < 12 - idMovCaja.length; i++) {
        zerosString = zerosString.concat('0')
    }
    return zerosString.concat(idMovCaja)
}

export default {
    getPaymentSummaries,
    fetchInitialResume,
    setInfoPaymentSummaries,
    setDetailCustomerSummaries,
    setDetailEmployeeSummaries,
    setDetailEgressSummaries,
    setTotalCustomerSummaries,
    setTotalEmployeeSummaries,
    printArqueo,
    setTotalIncome,
    setInitialAmountCash,
}
